import { getCookie } from "shared/utils/cookies";
import { configs } from "configuration";

// Helper to attach query params
const serializeQueryParams = (url, params = {}) => {
  let queryString = url.includes("?") ? "&" : "?";
  Object.keys(params).forEach((key) => {
    queryString += `${key}=${encodeURIComponent(params[key])}&`;
  });
  return `${url}${queryString}`;
};

// Build a Request object with headers, body, etc.
const createRequest = (url, reqConfig) => {
  let headers = {
    "Content-Type": "application/json",
    ...(reqConfig.header || {})
  };

  // Attach auth header if token is present
  const token = getCookie("accessToken");
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  // Serialize query params if provided
  if (reqConfig.query) {
    url = serializeQueryParams(url, reqConfig.query);
  }

  let requestOption = {
    method: reqConfig.method,
    headers,
    credentials: reqConfig.isCORS ? "include" : "same-origin"
  };

  // Handle body
  if (reqConfig.data) {
    requestOption.body =
      typeof reqConfig.data !== "string"
        ? JSON.stringify(reqConfig.data)
        : reqConfig.data;
  } else if (reqConfig.body) {
    requestOption.body = reqConfig.body;
  }

  // ✅ FIX: correctly attach signal
  if (reqConfig.signal) {
    requestOption.signal = reqConfig.signal;
  }

  return new Request(url, requestOption);
};

// Central fetch handler
const sendRequest = (url, options, fullURL = false) => {
  let path = url;

  // Prepend API host unless fullURL is true
  if (
    !fullURL &&
    (process.env.REACT_APP_ENV === "prod" ||
      process.env.REACT_APP_ENV === "dev")
  ) {
    path = configs().API_HOST + url;
  }

  const request = createRequest(path, options);

  return fetch(request).then((response) =>
    response.json().then((json) =>
      response.ok ? json : Promise.reject(json)
    )
  );
};

// API wrapper
const KoAPI = {
  get: (url, options = {}) => {
    options.method = "GET";
    return sendRequest(url, options);
  },

  getURL: (url, options = {}) => {
    options.method = "GET";
    return sendRequest(url, options, true);
  },

  getBulk: (urlList, options = {}) => {
    return Promise.all(urlList.map((endpoint) => sendRequest(endpoint, options)));
  },

  post: (url, options = {}) => {
    options.method = options.method || "POST";
    return sendRequest(url, options);
  },

  update: (url, options = {}) => {
    options.method = "PUT";
    return sendRequest(url, options);
  },

  patch: (url, options = {}) => {
    options.method = "PATCH";
    return sendRequest(url, options);
  },

  delete: (url, options = {}) => {
    options.method = "DELETE";
    return sendRequest(url, options);
  }
};

export default KoAPI;
